<template>
    <AjanlatBase :titleExtra="titleExtra" >
        <div slot="biztositoi-adatok">
            Verzió: {{ version }} {{ name }}
        </div>
    </AjanlatBase>
</template>
<script>
import AjanlatBase from '../KGFBAjanlatBase.vue';

export default {
    components: { AjanlatBase },
    data() {
        return {
            name: 'AjanlatAdatokB1_V1',
            version: 'v1',
        };
    },
};
</script>
